import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';

const SKELETON_ITEMS = 6;

const SkeletonUserList = () => (
  <div className="px-3 pb-3">
    <style>{`
      @keyframes skeletonPulse {
        0%   { opacity: 0.15; }
        50%  { opacity: 0.30; }
        100% { opacity: 0.15; }
      }
      .skeleton-bar {
        border-radius: 4px;
        background-color: #8898aa;
        animation: skeletonPulse 1.4s ease-in-out infinite;
      }
    `}</style>
    <ListGroup
      className="list"
      flush
      style={{
        width: '100%',
        borderRadius: '0.5rem',
        overflow: 'hidden',
        border: '1px solid #e9ecef',
      }}
    >
      <div style={{ padding: '2px' }}>
        {Array.from({ length: SKELETON_ITEMS }, (_, idx) => (
          <ListGroupItem
            key={idx}
            className="px-0"
            style={{ borderRadius: '10px' }}
          >
            <div
              style={{
                borderRadius: '0.5rem',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(50, 50, 93, 0.15)',
                border: '1px solid #e9ecef',
                padding: '12px 16px 12px 50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <div
                  className="skeleton-bar"
                  style={{
                    height: 14,
                    width: `${120 + (idx % 3) * 30}px`,
                    marginBottom: 6,
                    animationDelay: `${idx * 0.05}s`,
                  }}
                />
                <div
                  className="skeleton-bar"
                  style={{
                    height: 10,
                    width: `${80 + (idx % 4) * 20}px`,
                    animationDelay: `${idx * 0.05 + 0.1}s`,
                  }}
                />
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <div
                  className="skeleton-bar"
                  style={{
                    height: 30,
                    width: 100,
                    borderRadius: 4,
                    animationDelay: `${idx * 0.05 + 0.2}s`,
                  }}
                />
                <div
                  className="skeleton-bar"
                  style={{
                    height: 30,
                    width: 30,
                    borderRadius: 4,
                    animationDelay: `${idx * 0.05 + 0.3}s`,
                  }}
                />
              </div>
            </div>
          </ListGroupItem>
        ))}
      </div>
    </ListGroup>
  </div>
);

export default SkeletonUserList;
